import styles from './PageHeader.module.scss'
import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";

const PageHeader = (props) => {
    const storeHeader = useSelector((state) => state.app.pageHeader)
    const [currentHeader, setCurrentHeader] = useState(null);

    useEffect(() => {
        setCurrentHeader(storeHeader)
    }, [storeHeader]);

    return (
        <div className={styles.container}>
            <div className={styles.pageHeaderContainer}>
                { currentHeader ?
                    <div className={styles.pageHeader}>
                        {currentHeader}
                    </div>
                :
                null
                }
            </div>
        </div>
    )
};

export default PageHeader;
